export const CHATBOT_API_URL = "https://api.pernexium.com/chatbot/api";
